
export const mutations = {
    STORE_USERS(state, users) {
        state.users = users
    },
    STORE_USER_UPDATE(state, userid) {
        let User = state.users.find(function (user) {
            return user.id === userid
        })
        state.systemUser = User
    }

}

export default mutations


// WEBPACK FOOTER //
// ./src/vuex/modules/users/mutations.js